import { isValidPhoneNumber } from "libphonenumber-js";

/*
 * A phone number Healthlink can dial from anywhere: written with its country code, so a referral's
 * out-of-hours number reaches the practice from a hospital switchboard (KIN-5 / KIN-2131).
 * Shared by the profile's numbers and the practice's out-of-hours number so both refuse the same set.
 */
export const PHONE_NUMBER_ERROR =
  "Please enter a valid phone number with country code (e.g. +35 3831 234 567)";

/** What a form should accept: no number at all, or a valid one starting with "+". */
export const isAcceptedPhoneNumber = (phoneNumber) =>
  !phoneNumber ||
  (phoneNumber.startsWith("+") && isValidPhoneNumber(phoneNumber));
